import { useEffect, type ReactNode } from 'react';
import { useAuth } from '../lib/auth/useAuth';

type AuthGateProps = {
  children: ReactNode;
};

export function AuthGate({ children }: AuthGateProps) {
  const { user, isLoading, error } = useAuth();
  const needsLogin = !isLoading && (error !== null || !user);

  useEffect(() => {
    if (needsLogin && typeof window !== 'undefined') {
      window.location.assign('/api/auth/login');
    }
  }, [needsLogin]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Lade…</span>
        </div>
      </div>
    );
  }

  if (needsLogin) {
    return (
      <div className="alert alert-warning text-center" role="alert">
        Anmeldung erforderlich. Du wirst weitergeleitet…
      </div>
    );
  }

  return <>{children}</>;
}
